'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _nodePolyglot = require('node-polyglot');

var _nodePolyglot2 = _interopRequireDefault(_nodePolyglot);

var _reactAddonsUpdate = require('react-addons-update');

var _reactAddonsUpdate2 = _interopRequireDefault(_reactAddonsUpdate);

var _reactRedux = require('react-redux');

var _reactDocumentMeta = require('react-document-meta');

var _reactDocumentMeta2 = _interopRequireDefault(_reactDocumentMeta);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _queryString = require('query-string');

var _queryString2 = _interopRequireDefault(_queryString);

var _components = require('components');

var _OrderPick = require('components/Form/OrderPick');

var _OrderPick2 = _interopRequireDefault(_OrderPick);

var _events = require('redux/modules/events');

var _reactBootstrap = require('react-bootstrap');

var _reduxRouter = require('redux-router');

var _utils = require('utils');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _lodash = require('lodash.find');

var _lodash2 = _interopRequireDefault(_lodash);

var _can = require('helpers/can');

var _can2 = _interopRequireDefault(_can);

var _decorate = require('helpers/decorate');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Event = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    destroyed: state.events.destroyed,
    events: state.events.events,
    error: state.events.error,
    queryParams: state.events.queryParams,
    user: state.auth.user
  };
}, { changeFilter: _events.changeFilter, destroy: _events.destroy, feature: _events.feature, load: _events.load, push: _reduxRouter.push, replace: _reduxRouter.replace, restore: _events.restore, unlink: _events.unlink }), _dec2 = (0, _decorate.container)(['openModal', 'closeModal']), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Event, _Component);

  function Event(props, context, updater) {
    (0, _classCallCheck3.default)(this, Event);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Event.__proto__ || (0, _getPrototypeOf2.default)(Event)).call(this, props, context, updater));

    _this.state.snackbar = (0, _utils.snackbarInitialState)();
    return _this;
  }

  (0, _createClass3.default)(Event, [{
    key: 'onFilterEvents',
    value: function onFilterEvents(event) {
      var _this2 = this;

      if (this.filterTextListener) {
        clearTimeout(this.filterTextListener);
      }

      var term = event.target.value.trim();
      this.filterTextListener = setTimeout(function () {
        _this2.onPagerSelect({
          q: term,
          page: 1
        });
      }, 800);
    }
  }, {
    key: 'onFilterDate',
    value: function onFilterDate(event) {
      this.onPagerSelect({
        range: event.target.value,
        page: 1
      });
    }
  }, {
    key: 'onComponentWillReceiveProps',
    value: function onComponentWillReceiveProps(newProps) {
      var parts = newProps.location.pathname.split('/');
      this.setState({
        isOptionsModalOpen: parts[parts.length - 1] === 'settings',
        isWidgetModalOpen: parts[parts.length - 1] === 'widget'
      });
    }
  }, {
    key: 'onPagerSelect',
    value: function onPagerSelect(newParams) {
      var queryParams = this.props.queryParams;
      var calendarId = this.props.params.calendarId;
      var push = this.props.push; // eslint-disable-line no-shadow

      queryParams = (0, _extends3.default)({}, queryParams, newParams);

      if (calendarId) {
        delete queryParams.organization_id;
        queryParams.calendar_id = calendarId;
        push({ pathname: '/calendars/' + calendarId, query: queryParams });
      } else {
        delete queryParams.organization_id;
        delete queryParams.calendar_id;
        push({ pathname: '/', query: queryParams });
      }
    }
  }, {
    key: 'onPageSelect',
    value: function onPageSelect(event, page) {
      event.preventDefault();
      return this.onPagerSelect({ page: page });
    }
  }, {
    key: 'onSelectSortOrder',
    value: function onSelectSortOrder(newParams) {
      var queryParams = this.props.queryParams;


      var newFilter = {
        order: newParams,
        page: 1
      };

      if (newParams !== queryParams.order) {
        newFilter.direction = 'asc';
      } else {
        newFilter.direction = queryParams.direction === 'asc' ? 'desc' : 'asc';
      }

      this.onPagerSelect(newFilter);
    }
  }, {
    key: 'onSelectSortOrderDirection',
    value: function onSelectSortOrderDirection() {
      this.onPagerSelect({
        page: 1,
        direction: this.props.queryParams.direction === 'asc' ? 'desc' : 'asc'
      });
    }
  }, {
    key: 'onSelectStatus',
    value: function onSelectStatus(event) {
      this.onPagerSelect({
        page: 1,
        status: event.target.value
      });
    }
  }, {
    key: 'onSelectAuthor',
    value: function onSelectAuthor(event) {
      this.onPagerSelect({
        page: 1,
        author: event.target.value
      });
    }
  }, {
    key: 'beforeOnMount',
    value: function beforeOnMount() {
      var parts = this.props.location.pathname.split('/');
      this.setState({
        isOptionsModalOpen: parts[parts.length - 1] === 'settings',
        isWidgetModalOpen: parts[parts.length - 1] === 'widget'
      });
    }
  }, {
    key: 'openModal',
    value: function openModal(selectedEvent) {
      var _props = this.props,
          calendarId = _props.params.calendarId,
          push = _props.push,
          queryParams = _props.queryParams; // eslint-disable-line no-shadow

      if (calendarId) {
        push({ pathname: '/calendars/' + calendarId + '/events/' + (selectedEvent.id || 'new'), query: queryParams });
      } else {
        push({ pathname: '/events/' + (selectedEvent.id || 'new'), query: queryParams });
      }
    }
  }, {
    key: 'openOptionsModal',
    value: function openOptionsModal() {
      this.setState({
        isOptionsModalOpen: true
      });
    }
  }, {
    key: 'openWidgetModal',
    value: function openWidgetModal() {
      this.setState({
        isWidgetModalOpen: true
      });
    }
  }, {
    key: 'reloadEvents',
    value: function reloadEvents() {
      var _props2 = this.props,
          queryParams = _props2.queryParams,
          load = _props2.load; // eslint-disable-line no-shadow

      load(queryParams);
    }
  }, {
    key: 'handleDestroy',
    value: function handleDestroy(eventId, evt) {
      var _this3 = this;

      evt.preventDefault();

      var _props3 = this.props,
          destroy = _props3.destroy,
          locale = _props3.user.lang; // eslint-disable-line no-shadow

      var eventPhrases = require('./../../locales/' + locale + '/events.js');
      var appPhrases = require('./../../locales/' + locale + '/app.js');
      var polyglot = new _nodePolyglot2.default({
        locale: locale,
        phrases: (0, _extends3.default)({}, appPhrases, eventPhrases)
      });
      _moment2.default.locale(polyglot.locale, require('./../../locales/' + locale + '/calendar.js'));

      destroy(eventId).then(function (res) {
        if (res.type === 'caligram/events/DESTROY_SUCCESS') {
          var snackbar = _this3.state.snackbar;


          snackbar = (0, _reactAddonsUpdate2.default)(snackbar, {
            $merge: {
              id: eventId,
              isActive: true,
              message: polyglot.t('snackbar.eventDestroyed', { title: res.result.title ? (0, _utils.trunc)(res.result.title, 20, true) : '' }),
              action: polyglot.t('snackbar.undo'),
              currentAction: res.type
            }
          });

          _this3.setState({ snackbar: snackbar });
        }
      });
    }
  }, {
    key: 'handleUnlink',
    value: function handleUnlink(eventId, calendarId, evt) {
      var _this4 = this;

      evt.preventDefault();

      var _props4 = this.props,
          unlink = _props4.unlink,
          locale = _props4.user.lang; // eslint-disable-line no-shadow

      var eventPhrases = require('./../../locales/' + locale + '/events.js');
      var appPhrases = require('./../../locales/' + locale + '/app.js');
      var polyglot = new _nodePolyglot2.default({
        locale: locale,
        phrases: (0, _extends3.default)({}, appPhrases, eventPhrases)
      });
      _moment2.default.locale(polyglot.locale, require('./../../locales/' + locale + '/calendar.js'));

      unlink(eventId, calendarId).then(function (res) {
        if (res.type === 'caligram/events/UNLINK_SUCCESS') {
          var snackbar = _this4.state.snackbar;

          var calendarName = '';
          if (res.result.calendar && res.result.calendar.name) {
            calendarName = (0, _utils.trunc)(res.result.calendar.name, 20, true);
          }

          snackbar = (0, _reactAddonsUpdate2.default)(snackbar, {
            $merge: {
              id: eventId,
              isActive: true,
              message: polyglot.t('snackbar.eventUnlinked', {
                title: res.result.title ? (0, _utils.trunc)(res.result.title, 20, true) : '',
                calendar: calendarName
              }),
              action: false, // TODO
              currentAction: res.type
            }
          });

          _this4.setState({ snackbar: snackbar });
        }
      });
    }
  }, {
    key: 'toggleFeature',
    value: function toggleFeature(event, evt) {
      evt.preventDefault();

      var _props5 = this.props,
          feature = _props5.feature,
          calendarId = _props5.params.calendarId; // eslint-disable-line no-shadow

      if (!calendarId) {
        return;
      }

      feature(event.id, calendarId);
    }
  }, {
    key: 'hideSnackbar',
    value: function hideSnackbar() {
      var snackbar = this.state.snackbar;


      snackbar = (0, _reactAddonsUpdate2.default)(snackbar, {
        $merge: {
          id: 0,
          isActive: false
        }
      });

      this.setState({ snackbar: snackbar });
    }
  }, {
    key: 'handleDismissSnackbar',
    value: function handleDismissSnackbar() {
      this.hideSnackbar();
    }
  }, {
    key: 'handleClickSnackbar',
    value: function handleClickSnackbar() {
      var _this5 = this;

      var snackbar = this.state.snackbar;


      switch (snackbar.currentAction) {
        case 'caligram/events/DESTROY_SUCCESS':
          var _props6 = this.props,
              _restore = _props6.restore,
              destroyed = _props6.destroyed; // eslint-disable-line no-shadow

          _restore(destroyed.id).then(function (res) {
            if (res.type === 'caligram/events/RESTORE_SUCCESS') {
              _this5.hideSnackbar();
            }
          });
          break;
        default:
          break;
      }
    }
  }, {
    key: 'closeModal',
    value: function closeModal() {
      var _props7 = this.props,
          calendarId = _props7.params.calendarId,
          push = _props7.push,
          queryParams = _props7.queryParams; // eslint-disable-line no-shadow

      if (calendarId) {
        push({ pathname: '/calendars/' + calendarId, query: queryParams });
      } else {
        push({ pathname: '/', query: queryParams });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this6 = this,
          _context2;

      var locale = this.props.user.lang;


      var eventPhrases = require('./../../locales/' + locale + '/events.js');
      var appPhrases = require('./../../locales/' + locale + '/app.js');
      var calendarPhrases = require('./../../locales/' + locale + '/calendars.js');
      var polyglot = new _nodePolyglot2.default({
        locale: locale,
        phrases: (0, _extends3.default)({}, appPhrases, eventPhrases, calendarPhrases)
      });
      _moment2.default.locale(polyglot.locale, require('./../../locales/' + locale + '/calendar.js'));
      var newEventClasses = (0, _classnames2.default)('btn', 'btn-lg', 'btn-primary', 'pull-right');
      var calendarOptionsClasses = (0, _classnames2.default)('btn', 'btn-lg', 'btn-default', 'pull-right');
      var snackbar = this.state.snackbar;
      var _props8 = this.props,
          user = _props8.user,
          events = _props8.events,
          paramsCalendarId = _props8.params.calendarId,
          queryParams = _props8.queryParams;

      var calendarId = isNaN(parseInt(paramsCalendarId, 10)) ? null : parseInt(paramsCalendarId, 10);

      var calendars = user ? user.calendars : [];
      var calendar = Array.isArray(calendars) ? (0, _lodash2.default)(calendars, { id: calendarId }) : null;

      var meta = {
        pagination: {
          current_page: 0,
          total: 0,
          total_pages: 0
        }
      };

      if (events && events.meta) {
        meta = events.meta;
      }

      var eventData = [];
      if (events && events.data) {
        eventData = events.data;
      }

      var pagerPrevDisabled = meta.pagination.current_page <= 1;
      var pagerNextDisabled = meta.pagination.current_page >= meta.pagination.total_pages;

      var eventList = eventData.length ? _react2.default.createElement(
        'div',
        { className: 'results' },
        _react2.default.createElement(
          _OrderPick2.default,
          { type: 'events', queryParams: queryParams, total: meta.pagination.total, onPagerSelect: this.onPagerSelect.bind(this), polyglot: polyglot },
          _react2.default.createElement(
            _reactBootstrap.MenuItem,
            { eventKey: 'created_at' },
            polyglot.t('events.sortOrder.created_at')
          ),
          _react2.default.createElement(
            _reactBootstrap.MenuItem,
            { eventKey: 'updated_at' },
            polyglot.t('events.sortOrder.updated_at')
          ),
          _react2.default.createElement(
            _reactBootstrap.MenuItem,
            { eventKey: 'start_date' },
            polyglot.t('events.sortOrder.start_date')
          ),
          _react2.default.createElement(
            _reactBootstrap.MenuItem,
            { eventKey: 'title' },
            polyglot.t('events.sortOrder.title')
          )
        ),
        eventData.map(function (event) {
          var _context;

          return _react2.default.createElement(_components.EventItem, {
            key: String(event.id),
            event: event,
            openModal: (_context = _this6.openModal).bind.call(_context, _this6, event),
            destroy: _this6.handleDestroy.bind(_this6),
            feature: _this6.toggleFeature.bind(_this6),
            polyglot: polyglot,
            calendar: calendar,
            moment: _moment2.default,
            unlink: _this6.handleUnlink.bind(_this6)
          });
        })
      ) : _react2.default.createElement(
        'div',
        { className: 'results empty' },
        polyglot.t('events.empty')
      );

      var pages = (0, _utils.pagination)(meta.pagination.current_page, meta.pagination.total_pages);
      var pager = meta.pagination.total_pages > 1 ? _react2.default.createElement(
        _reactBootstrap.Pagination,
        { size: 'lg' },
        _react2.default.createElement(_reactBootstrap.Pagination.Prev, { onClick: function onClick(e) {
            return _this6.onPageSelect(e, meta.pagination.current_page - 1);
          } }),
        pages.map(function (p, i) {
          var pageNumber = p + 1;
          return p !== '...' ? _react2.default.createElement(
            _reactBootstrap.Pagination.Item,
            {
              key: 'page_' + i,
              className: 'button',
              active: meta.pagination.current_page === pageNumber,
              onClick: function onClick(e) {
                return _this6.onPageSelect(e, pageNumber);
              }
            },
            p + 1
          ) : _react2.default.createElement(_reactBootstrap.Pagination.Ellipsis, null);
        }),
        _react2.default.createElement(_reactBootstrap.Pagination.Next, { disabled: pagerNextDisabled, onClick: function onClick(e) {
            return _this6.onPageSelect(e, meta.pagination.current_page + 1);
          } })
      ) : null;

      var title = calendar ? calendar.name : polyglot.t('events.allEvents');
      var calendarUrl = void 0;
      if (calendar) {
        var calendarTranslation = calendar.translations.filter(function (t) {
          return t.lang === locale;
        });
        if (calendarTranslation.length > 0) {
          calendarUrl = calendarTranslation[0].url;
        }
      }

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_reactDocumentMeta2.default, { title: title + ' - Caligram' }),
        _react2.default.createElement(
          'div',
          { className: 'header' },
          (calendar || calendars.length === 0) && _react2.default.createElement(
            'button',
            {
              type: 'button',
              className: newEventClasses,
              onClick: (_context2 = this.openModal).bind.call(_context2, this, {})
            },
            polyglot.t(calendar ? 'events.addEvent' : 'events.createEvent')
          ),
          calendar && (0, _can2.default)('admin', calendar) && _react2.default.createElement(
            _reactRouter.Link,
            {
              to: '/calendars/' + calendar.id + '/settings',
              className: calendarOptionsClasses
            },
            polyglot.t('calendars.calendarOptions')
          ),
          calendar && calendar.options && calendar.options.widget && _react2.default.createElement(
            _reactRouter.Link,
            {
              to: '/calendars/' + calendar.id + '/widget',
              className: calendarOptionsClasses
            },
            polyglot.t('calendars.createWidget')
          ),
          _react2.default.createElement(
            'h1',
            null,
            title
          ),
          calendarUrl && _react2.default.createElement(
            'a',
            { className: 'secondary', href: calendarUrl },
            calendarUrl
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'filters' },
          _react2.default.createElement(
            'div',
            { className: 'form-inline' },
            _react2.default.createElement(
              'label',
              { className: 'select-wrapper' },
              _react2.default.createElement(
                'select',
                { name: 'event-date-filter', className: 'form-control', value: queryParams.range, onChange: this.onFilterDate.bind(this) },
                _react2.default.createElement(
                  'option',
                  { value: 'future' },
                  polyglot.t('events.dateFilter.future')
                ),
                _react2.default.createElement(
                  'option',
                  { value: 'past' },
                  polyglot.t('events.dateFilter.past')
                ),
                _react2.default.createElement(
                  'option',
                  { value: 'all' },
                  polyglot.t('events.dateFilter.all')
                )
              )
            ),
            _react2.default.createElement(
              'label',
              { className: 'select-wrapper' },
              _react2.default.createElement(
                'select',
                { name: 'event-status-filter', className: 'form-control', value: queryParams.status, onChange: this.onSelectStatus.bind(this) },
                _react2.default.createElement(
                  'option',
                  { value: 'all' },
                  polyglot.t('events.statusFilter.all')
                ),
                _react2.default.createElement(
                  'option',
                  { value: 'published' },
                  polyglot.t('events.statusFilter.published')
                ),
                _react2.default.createElement(
                  'option',
                  { value: 'partially_published' },
                  polyglot.t('events.statusFilter.partiallyPublished')
                ),
                _react2.default.createElement(
                  'option',
                  { value: 'pending' },
                  polyglot.t('events.statusFilter.pending')
                ),
                _react2.default.createElement(
                  'option',
                  { value: 'declined' },
                  polyglot.t('events.statusFilter.declined')
                ),
                _react2.default.createElement(
                  'option',
                  { value: 'draft' },
                  polyglot.t('events.statusFilter.draft')
                ),
                _react2.default.createElement(
                  'option',
                  { value: 'deleted' },
                  polyglot.t('events.statusFilter.deleted')
                )
              )
            ),
            polyglot.t('events.authorFilter.createdBy'),
            _react2.default.createElement(
              'label',
              { className: 'select-wrapper with-label' },
              _react2.default.createElement(
                'select',
                { name: 'event-author-filter', className: 'form-control', value: queryParams.author, onChange: this.onSelectAuthor.bind(this) },
                _react2.default.createElement(
                  'option',
                  { value: 'all' },
                  polyglot.t('events.authorFilter.all')
                ),
                _react2.default.createElement(
                  'option',
                  { value: 'me' },
                  polyglot.t('events.authorFilter.me')
                ),
                _react2.default.createElement(
                  'option',
                  { value: 'other' },
                  polyglot.t('events.authorFilter.other')
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'form-group pull-right' },
              _react2.default.createElement('input', { type: 'search', className: 'form-control', placeholder: '\xA0', defaultValue: queryParams.q, onChange: this.onFilterEvents.bind(this) })
            )
          )
        ),
        eventList,
        pager,
        _react2.default.createElement(_components.EventModal, {
          isModalOpen: this.state.isModalOpen,
          closeModal: this.closeModal.bind(this),
          calendar: calendar,
          eventId: this.state.selectedEditItem.id,
          polyglot: polyglot
        }),
        _react2.default.createElement(_components.CalendarOptionsModal, {
          isModalOpen: this.state.isOptionsModalOpen,
          closeModal: this.closeModal.bind(this),
          calendarId: calendarId,
          polyglot: polyglot
        }),
        _react2.default.createElement(_components.EventWidget, {
          isModalOpen: this.state.isWidgetModalOpen,
          closeModal: this.closeModal.bind(this),
          calendarId: calendarId,
          polyglot: polyglot
        }),
        _react2.default.createElement(_components.Snackbar, (0, _extends3.default)({
          ref: 'snackbar'
        }, snackbar, {
          style: (0, _utils.snackbarStyle)(),
          onDismiss: this.handleDismissSnackbar.bind(this),
          onClick: this.handleClickSnackbar.bind(this),
          polyglot: polyglot
        }))
      );
    }
  }], [{
    key: 'fetchData',
    value: function fetchData(getState, dispatch, location) {
      var state = getState();
      var queryParams = state.events.queryParams;

      var parsedParams = _queryString2.default.parse(location.search);

      var parts = location.pathname.split('/');
      var urlCalendarId = parts.length > 2 && parts[1] !== 'events' ? parts[2] : null;

      var mergedParams = (0, _extends3.default)({}, queryParams, parsedParams, {
        calendar_id: urlCalendarId
      });

      var paramsChanged = _queryString2.default.stringify(queryParams) !== _queryString2.default.stringify(mergedParams);
      if (paramsChanged || !(state.events.loaded || state.events.loading)) {
        dispatch((0, _events.changeFilter)(mergedParams));

        return dispatch((0, _events.load)(mergedParams));
      }
    }
  }]);
  return Event;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object,
  changeFilter: _propTypes2.default.func,
  destroy: _propTypes2.default.func.isRequired,
  destroyed: _propTypes2.default.object,
  events: _propTypes2.default.object,
  error: _propTypes2.default.any,
  feature: _propTypes2.default.func.isRequired,
  load: _propTypes2.default.func,
  location: _propTypes2.default.object,
  params: _propTypes2.default.object,
  push: _propTypes2.default.func.isRequired,
  replace: _propTypes2.default.func.isRequired,
  queryParams: _propTypes2.default.object,
  restore: _propTypes2.default.func.isRequired,
  unlink: _propTypes2.default.func.isRequired
}, _temp)) || _class) || _class);
exports.default = Event;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Event/Event.js
// module id = 2265
// module chunks = 0